import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleResourceManager } from "../hooks/roles/ProtectedRoleResourceManager";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";

const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareaDetalleEvaluarDisponibilidad = React.lazy(
  () =>
    import(
      "../components/task/tecnical/tareaDetalleEvaluarDisponibilidad/tarea-detalle-evaluar-disponibilidad"
    )
);
export function tareaDetalleEvaludarDisponibilidad() {
  return (
    <Route
      path="/tarea-detalle-evaluar-disponibilidad"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedRoleResourceManager>
              <LazySuspense>
                <TareaDetalleEvaluarDisponibilidad />
              </LazySuspense>
            </ProtectedRoleResourceManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
